import * as React from "react";
import styles = require("./style.less");
import * as cn from "classnames";

const ComponentRow = (props: any) => {
    return <div className={cn(styles.componentRow, props.className)}>
        {props.children}
    </div>;
};

(ComponentRow as any).displayName = "ComponentRow";

export default ComponentRow;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ComponentRow/ComponentRow.tsx